import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { commonStyles } from '../commonStyles';
import { ProductCardVariantType } from '../variants';
export const getCreditCardsStyles = (FOUNDATIONS) => ({
    [ProductCardVariantType.CREDIT_CARDS]: {
        ...commonStyles(FOUNDATIONS, {
            columnContainer: {
                padding_left: FOUNDATIONS.spacing_250,
                [DeviceBreakpointsType.MOBILE]: {
                    padding_left: FOUNDATIONS.spacing_250,
                    padding_right: FOUNDATIONS.spacing_250,
                    padding_top: FOUNDATIONS.spacing_00,
                },
            },
            centerInfoContainer: {
                margin_bottom: FOUNDATIONS.spacing_150,
                [DeviceBreakpointsType.MOBILE]: {
                    margin_top: FOUNDATIONS.spacing_250,
                    margin_bottom: FOUNDATIONS.spacing_150,
                    margin_right: FOUNDATIONS.spacing_250,
                    margin_left: FOUNDATIONS.spacing_250,
                },
            },
        }),
    },
});
//# sourceMappingURL=creditCards.js.map